import React from 'react'
import { Flex, Typography, Tag } from 'antd'
import * as AntdIcons from '@ant-design/icons';

const { Title, Text } = Typography

const Counter = ({ planningCount }) => {
  return (
    <Flex gap={16} justify='flex-end' >

      <Flex gap={8} justify='center' align='center'>
        <Title level={3}>Planning Completed</Title>
        <Tag color='success'>
          <AntdIcons.FileDoneOutlined />
          <Text>{planningCount?.completed}</Text>
        </Tag>
      </Flex>

      <Flex gap={8} justify='center' align='center'>
        <Title level={3}>Total Planning</Title>
        <Tag color='cyan'>
          <AntdIcons.FileAddOutlined />
          <Text>{planningCount?.total}</Text>
        </Tag>
      </Flex>

    </Flex>
  )
}

export default Counter
